// src/Components/TopBar/AccountantQuickLinks.tsx
import QuickLinkButton from './QuickLinkButton';

// ⬇️  replace with your own SVGs in assets/icons
import {
  TimesheetIcon,
  QBOIcon,
  DeelIcon,
  MondayIcon,
  SlackIcon,
  OutlookIcon,
  ArrowDownIcon as ChevronDownIcon,
  ProconnectIcon,
} from 'assets/icons';

import React, { useState } from 'react';

const LINKS = [
  {
    label: 'Timesheets',
    href: 'https://tsheets.intuit.com',
    Icon: TimesheetIcon,
  },
  { label: 'QBO', href: 'https://app.qbo.intuit.com', Icon: QBOIcon },
  { label: 'Deel', href: 'https://app.deel.com', Icon: DeelIcon },
  { label: 'Monday', href: 'https://monday.com', Icon: MondayIcon },
  { label: 'Slack', href: 'https://app.slack.com', Icon: SlackIcon },
  { label: 'Outlook', href: 'https://outlook.office.com', Icon: OutlookIcon },
  {
    label: 'ProConnect',
    href: 'https://proconnect.intuit.com',
    Icon: ProconnectIcon,
  },
] as const;

export default function AccountantQuickLinks() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* DESKTOP GRID */}
      <div className="hidden md:grid grid-cols-7 gap-1 mr-1">
        {LINKS.map(({ label, href, Icon }) => (
          <QuickLinkButton key={label} href={href} label={label} Icon={Icon} />
        ))}
      </div>

      {/* MOBILE DROPDOWN */}
      <div className="md:hidden relative ml-2">
        <button
          onClick={() => setOpen((o) => !o)}
          className="flex items-center px-2 py-1 bg-white text-green font-bold rounded shadow-sm button-wrapper"
        >
          Platforms
          <ChevronDownIcon className="w-4 h-4 ml-1 text-green" />
        </button>

        {open && (
          <div
            className="absolute right-0 mt-1 w-40 border border-gray-200 rounded shadow-lg z-20"
            style={{ backgroundColor: '#fff' /* guarantee 100% white */ }}
          >
            {LINKS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 text-sm text-gray-900 hover:bg-gray-100 dark:text-gray-100 dark:hover:bg-gray-700"
                style={{ color: '#111' }}
              >
                {label}
              </a>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
